import request from './axios'

// 登录日志
export const logLogin = (params) =>{
   return request({
        url:'/logManagement/login',
        method: "post",
        data: params,
   })
}

// 上行日志/下行日志
export const logManagementUpLog = (params) =>{
   return request({
     url:'/logManagement/upLog',
     method: "post",
     data: params,
   })
 }
 //单个切换服务
 export const DeviceQiehuan = (params) => {
   return request({
      url:'/device/switchingService',
      method:'get',
      params
      
   })
}
//电信上行日志
export const telecomUpLogFind   = (params) =>{
   return request({
        url:'/logManagement/telecomUpLog',
        method: "post",
        data: params,
   })
}
//考勤日志
export const logManagementLog   = (params) =>{
   return request({
        url:'/logManagement/attendanceLog',
        method: "post",
        data: params,
   })
}
// 活跃用户统计
export const activeUser = (params) => {
   return request({
     url: `/logManagement/activeUser`,
     method: "post",
     data:params,
   });
 };
//定时开关机
export const timeSwitchFind = (params) => {
   return request({
      url:'/setSystem/timeSwitch/find',
      method:'get',
      params
      
   })
}
// 定时开关设置修改 /setSystem/timeSwitch/update
export const timeSwitchUpdate = (params) => {
   return request ({
      url:'/setSystem/timeSwitch/update',
      method:'post',
      data:params
      
   })
}


// 隐身设置-查询
export const setSystemHidingFing = (params) => {
   return request ({
      url:'/setSystem/hiding/find',
      method:'get',
      params
   })
}
//  隐身设置修改
export const setSystemHidingUpdate = (params) => {
   return request ({
      url:"/setSystem/hiding/update",
      method:'post',
      data:params
   })
}

// 定时跟踪-设置
export const timeFollowSet = (params) => {
   return request({
     url: `/setSystem/timeFollow/set`,
     method: "post",
     data:params,
   });
 };
//  定时跟踪查询
 export const timeFollowFind = (params) => {
   return request({
     url: `/setSystem/timeFollow/find`,
     method: "get",
     params:params,
   });
 };
// 公司信息详情查询/setSystem/companyInfoManagement/findDetails
export const setSystemCompanyInfoFind = (params) => {
   return request({
      url:'/setSystem/companyInfoManagement/findDetails',
      method:'get',
      params
   })
}

// 公司信息管理/setSystem/companyInfoManagement
export const companyInfoManagement = (params) => {
   return request ({
      url:'/setSystem/companyInfoManagement',
      method:'post',
      data:params
   })
}
//公司信息新增
export const GongsixinxiAdd = (params) => {
   return request ({
      url:'/setSystem/companyInfoManagement/addOrUpdate',
      method:'post',
      data:params
   })
}
// /setSystem/userTree用户树
export const setSystemUserTree = (params) => {
   return request ({
      url:'/setSystem/userTree',
      method:'get',
      params
   })
}

//会员列表 /member/list
export const memberList = (params) => {
   return request({
      url:"/member/list",
      method:'post',
      data:params
   })

} 
// 会员信息删除 
export const memberDelete = (params) => {
   return request({
      url:'/member/delete',
      method:'post',
      data:params

   })
}
// 会员状态修改
export const memberUpdateStatus = (memberId ,status) => {
   return request({
      url:`/member/updateStatus?memberId=${memberId}&status=${status}`,
      method:'put',
   })

}
// 会员详情信息/member/details
export const memberDetailsInfo = (memberId) => {
   return request({
      url:`/member/details?memberId=${memberId}`,
      method:"get",
   })
}

//会员修改信息/member/update
export const memberUpdate = (params) => {
   return request({
      url:"/member/update",
      method:"post",
      data:params
   })
}
// 会员新增 /member/add
export const memberAddInfo = (params)=> {
   return request({
      url:"/member/add",
      method:"post",
      data:params
   })
}

// 会员导入 /member/add
export const memberImportMember = (params,id)=> {
   return request({
      url:`/member/importMember?userId=${id}`,
      method:"post",
      data:params
   })
}
// 会员导出 /member/add
export const memberExportMember = (params)=> {
   return request({
      url:`/member/exportMember`,
      responseType: 'blob',
      method:"post",
      data:params

   })
}
// 会员imei列表
export const BindImeiList = (params) => {
   return request({
      url:"/member/findMemberBindImeiList",
      method:"get",
      params
   })
}

export const bindDevice = (params)=> {
   return request({
      url:`/member/bindDevice`,
      method:"post",
      data:params

   })
}

// 查询会员绑定关系
export const LookVipImei = (memberId ) => {
   return request({
      url:`/member/findMemberBindStudentList?memberId=${memberId }`,
      method:"get",
   })
}
//宿舍管理员列表
export const SuSheListMember = (params,userId,type=1)=> {
   return request({
      url:`/member/dormitoryMember/list?userId=${userId}&type=${type}`,
      method:"post",
      data:params

   })
}